<div class="header ag-ma-md">
  <h2>Browse Search</h2>
  <form class="form-inline" [formGroup]="browseForm" (ngSubmit)="setQueryParams()">
    <div class="row align-items-center">
      <div class="col-sm-12 col-md-6 col-lg-3">
        <input
          agAutofocus
          aria-label="Search Term"
          formControlName="searchTerm"
          type="text"
          class="form-control form-group__input"
          [ngClass]="{
            'border-red':
              !browseForm.controls.searchTerm.valid && browseForm.controls.searchTerm.dirty
          }"
        />
        <!-- Does this need to be a label? -->
        <label
          *ngIf="!browseForm.controls.searchTerm.valid && browseForm.controls.searchTerm.dirty"
          class="red"
          for="searchTerm"
        >
          Please Enter a Search
        </label>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-3">
        <select formControlName="index" class="form-select">
          <option *ngFor="let index of indexes" [ngValue]="index.value">{{ index.label }}</option>
        </select>
      </div>
      <div class="col-auto">
        <div class="row align-items-center">
          <label class="col" style="white-space: nowrap" for="page-count">Records Per Page:</label>
          <div class="col">
            <select formControlName="pageSize" id="page-count" class="form-select">
              <option *ngFor="let pageSize of pageSizes" [ngValue]="pageSize">
                {{ pageSize }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col">
        <button
          class="btn search__button shadow btn-ripple"
          type="submit"
          aria-label="Browse Search"
          [disabled]="!browseForm.valid"
        >
          <i class="fa fa-search"></i>
          Browse Search
        </button>
      </div>
    </div>
  </form>

  <mat-spinner
    *ngIf="isLoading; else showBrowseTable"
    [diameter]="100"
    strokeWidth="3"
  ></mat-spinner>
  <ng-template #showBrowseTable>
    <div style="height: 38px; position: relative" class="ag-mb-sm">
      <ag-browse-table-paging
        class="paging"
        *ngIf="browseSearchData"
        [initialOffset]="initialSearchOffset"
        [currentOffset]="browseSearchData.currentSetId"
        [previousOffset]="browseSearchData.prevSetId"
        [nextOffset]="browseSearchData.nextSetId"
        (paging)="setQueryParams($event)"
      >
      </ag-browse-table-paging>
    </div>

    <ag-browse-table *ngIf="browseTerms" [browseTerms]="browseTerms"></ag-browse-table>

    <div style="height: 38px; position: relative">
      <ag-browse-table-paging
        class="bottom-paging"
        *ngIf="browseSearchData"
        [initialOffset]="initialSearchOffset"
        [currentOffset]="browseSearchData.currentSetId"
        [previousOffset]="browseSearchData.prevSetId"
        [nextOffset]="browseSearchData.nextSetId"
        (paging)="setQueryParams($event)"
      >
      </ag-browse-table-paging>
    </div>
  </ng-template>
</div>
